import { z } from "zod";

export const contributionGoalFormSchema = z.object({
  goal_name: z.string().min(1, "Goal name is required"),
  target_amount: z.coerce.number().positive("Target amount must be greater than 0"),
  target_type: z.enum(["deposits", "share_capital"], {
    errorMap: () => ({ message: "Target type must be 'deposits' or 'share_capital'" }),
  }),
  target_date: z.string().min(1, "Target date is required").refine(
    (val) => !isNaN(Date.parse(val)),
    "Invalid date"
  ),
  description: z.string().optional(),
});

export type ContributionGoalFormValues = z.infer<typeof contributionGoalFormSchema>;
